import { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setReviewCreationKey, useReviewCreationV1Data } from 'reducers/reviewCreationV1Slice';

import { ReviewCreationTimeline } from 'uiToolkitV1/ReviewCreationTimeline';
import { TextLabel } from 'uiToolkitV1/Typography';

import {
  ALL_SECTIONS_IN_ORDER,
  REVIEW_RESPONSE_PROVIDER_TYPE_WITH_REMINDER,
} from '../../configurePanels/TimelinesRemindersPanel';
import { SingleTypeReminders } from './OneTimeTimeline';

const SingleTimelineReminder = ({ singleTimelineData, singleTypeReminderData = [], reviewStage }) => {
  const { startDateOffset, endDateOffset } = singleTimelineData;
  const isReminderApplicable = REVIEW_RESPONSE_PROVIDER_TYPE_WITH_REMINDER.includes(reviewStage);

  const dispatch = useDispatch();

  const handleOpenTimelinePanel = () => {
    dispatch(setReviewCreationKey({ isTimelineRemindersPanelOpen: true }));
  };

  return (
    <>
      <Box cursor="pointer" onClick={handleOpenTimelinePanel}>
        <TextLabel>{`Day ${startDateOffset} to Day ${endDateOffset}`}</TextLabel>
      </Box>

      {isReminderApplicable && (
        <SingleTypeReminders
          singleTypeReminderData={singleTypeReminderData}
          handleOpenTimelinePanel={handleOpenTimelinePanel}
        />
      )}
    </>
  );
};

const ContinuousTimeline = () => {
  const { providerTimelineDetails, reminders } = useReviewCreationV1Data();

  const applicableSections = ALL_SECTIONS_IN_ORDER.filter((section) => providerTimelineDetails[section]);

  const timelineData = useMemo(
    () =>
      applicableSections.map((section, index) => ({
        reviewStage: section,
        detailsComp: (
          <SingleTimelineReminder
            singleTypeReminderData={reminders?.[section] ?? []}
            singleTimelineData={providerTimelineDetails[section]}
            reviewStage={section}
          />
        ),
      })),
    [applicableSections, reminders, providerTimelineDetails]
  );

  if (timelineData.length === 0) return null;

  return <ReviewCreationTimeline timelineData={timelineData} />;
};

export { ContinuousTimeline };
